class PetModal extends HTMLElement {
  constructor() {
    super();
  }
  // Initialize when component is added to DOM
  connectedCallback() {
    this.initializeComponent();
  }
  // Bootstraps all component features
  initializeComponent() {
    this.cacheElements();
    this.attachEventListeners();
  }
  // Attach UI event listeners
  attachEventListeners() {
    this.elements.openModalButton?.addEventListener("click", () =>{
      this.resetForm();
      this.clearAllErrors();
      this.elements.RxModal.close();
      addClass(this.elements.petModal,'model-open');
    });

    this.elements.closeModalButton?.addEventListener("click", () =>{
        this.closeModal();
    });
    this.elements.cancelModalButton?.addEventListener("click", () =>{
        this.closeModal();
    });

    this.elements.saveBtn?.addEventListener("click", (event) => {
      event.preventDefault(); // stop default weird behavior
      this.handleFormSubmit(event);
    });

    this.elements.form?.addEventListener("submit", (event) =>
      this.handleFormSubmit(event)
    );
  }
  clearAllErrors() {
    const fields = this.querySelectorAll('.field-input, select,.field-radio');
    fields.forEach(field => this.clearFieldError(field));
  }
  clearFieldError(field) {
    if (!field) return;

    field.classList.remove('field-error');

    const group = field.closest('.field-group');
    group?.classList.remove('is-error');

    const choices = field.closest('.choices');
    choices?.classList.remove('is-error');

    const errorEl = group?.querySelector('.field-error-message');
    if (errorEl) errorEl.remove();
  }
  // Cache DOM elements
  cacheElements() {
    this.elements = {
      RxModal: document.getElementById('PetVetModal'),
      feedback: this.querySelector("#feedbackMessage"),
      form: this.querySelector("#petForm"),
      openModalButton: document.querySelector("#create-new-pet-modal"),
      petModal: document.querySelector('[data-modal="add-pet-modal"]'),
      closeModalButton: this.querySelector('[data-modal="add-pet-modal"] .footer-cancel-btn'),
      cancelModalButton: this.querySelector('[data-modal="add-pet-modal"] .close-btn'),
      saveBtn: this.querySelector("#savePetButton")
    };
  }
  UpdatePetList(pet) {
    document.querySelectorAll('.pet-data-select').forEach((el) => {
        let choiceObject = window.choicesInstances[el.id];
        choiceObject.setChoices([{ value: pet.id, label: pet.pet_name, selected: false }]);
    });
    fetchPets();
  }
  async handleFormSubmit(event) {
    event.preventDefault();

    const payload = this.getFormData();
    if (!payload) return;

    try {
        let NewPetData = await this.createPet(payload);
        this.resetForm();
        this.closeModal();
        if(NewPetData.status == 200 && NewPetData?.data?.pet){
            this.UpdatePetList(NewPetData?.data?.pet);
        }
    } catch (error) {
      this.showError("Failed to save pet.");
    }
  }
  // Show error message
  showError(message) {
    this.updateFeedback(message, false);
  }

  // Update feedback UI
  updateFeedback(message, isSuccess) {
    const el = this.elements.feedback;
    if (!el) return;

    el.textContent = message;
    el.style.color = isSuccess ? "green" : "red";
  }
  closeModal(){
        this.elements.RxModal.showModal();
        removeClass(this.elements.petModal,'model-open');
  }
  // Reset form state
  resetForm() {
    this.elements.form?.reset();
    if (this.elements.form?.handle) {
      this.elements.form.handle.value = "";
    }

    // ✅ Destroy and reinit single selects — setChoiceByValue('') doesn't reset placeholder
    ['petType', 'birthMonth', 'birthDay', 'birthYear'].forEach(id => {
      const el = document.getElementById(id);
      const instance = window.choicesInstances?.[id];
      if (!instance || !el) return;

      instance.destroy();
      el.selectedIndex = 0; // reset native select to first option
      var searchEnabled = false;
      if (id == 'petType'){
        searchEnabled = true;
      }
      window.choicesInstances[id] = new Choices(el, {
        searchEnabled: searchEnabled,
        searchResultLimit: -1,
        itemSelectText: '',
        shouldSort: false
      });
    });

    // Reset multi selects
    ['allergies', 'medication', 'conditions'].forEach(id => {
      const instance = window.choicesInstances?.[id];
      if (instance) instance.removeActiveItems();
    });

    // Reset breed back to disabled state
    const breedEl = document.getElementById('petBreed');
    const breedChoices = window.choicesInstances?.['petBreed'];
    if (breedChoices && breedEl) {
      breedChoices.destroy();
      breedEl.selectedIndex = 0;
      const newBreedChoices = new Choices(breedEl, {
        searchEnabled: true,
        itemSelectText: '',
        searchResultLimit: -1,
        shouldSort: false
      });
      newBreedChoices.disable();
      newBreedChoices.setChoices(
        [{ value: '', label: 'Select type first', selected: true }],
        'value', 'label', true
      );
      window.choicesInstances['petBreed'] = newBreedChoices;
      breedEl.closest('.choices')?.style.setProperty('display', 'block');
    }

    // Reset custom breed input
    const customBreed = document.getElementById('customBreed');
    if (customBreed) {
      customBreed.style.display = 'none';
      customBreed.value = '';
      customBreed.required = false;
    }
  }
  createPet(payload) {
    return APIrequest("upsertPet", payload);
  }
  getFormData() {
    this.clearAllErrors();
    const form = this.elements.form;
    const formData = new FormData(form);

    const petName = formData.get('petName')?.trim();
    const petType = formData.get('petType')?.trim();
    const gender = formData.get('gender');

    // Birthdate
    const birthMonth = formData.get('birthMonth');
    const birthDay = formData.get('birthDay');
    const birthYear = formData.get('birthYear');

    let birthdate = '';

    const weight = formData.get('weight');

    const petBreed =
      formData.get('petBreed')?.trim() ||
      formData.get('customBreed')?.trim() ||
      "";

    let hasError = false;

    if (!petName) {
      this.showFieldError(form.petName, window.petname);
      hasError = true;
    }

    if (!petType) {
      this.showFieldError(form.petType, window.pettype);
      hasError = true;
    }

    // if (!petBreed) {
    //   this.showFieldError(form.petBreed, window.petbreed);
    //   hasError = true;
    // }

    if (!weight) {
      this.showFieldError(form.weight, window.weight);
      hasError = true;
    }

    if (!gender) {
      const genderField = form.querySelector('input[name="gender"]');
      this.showFieldError(genderField, window.petgender);
      hasError = true;
    }

    if (!birthMonth || !birthDay || !birthYear) {
      this.showFieldError(form.birthMonth, window.petbirthdate);
      hasError = true;
    } else {
      const paddedDay = String(birthDay).padStart(2, '0');

      // const date = new Date(`${birthYear}-${birthMonth}-${paddedDay}`);

      // const isValid =
      //   date.getFullYear() == birthYear &&
      //   (date.getMonth() + 1) == Number(birthMonth) &&
      //   date.getDate() == Number(paddedDay);

      // if (!isValid) {
      //   this.showFieldError(form.birthMonth, "Invalid birthdate");
      //   hasError = true;
      // } else {
        birthdate = `${birthMonth}/${paddedDay}/${birthYear}`;
      // }
    }

    // ❌ STOP if any error
    if (hasError) return null;

    // ✅ Arrays
    const cleanArray = (arr) =>
      arr.filter(v => v && v !== 'None');

    const medication = cleanArray(formData.getAll('medication[]'));
    const allergies = cleanArray(formData.getAll('allergies[]'));
    const conditions = cleanArray(formData.getAll('conditions[]'));

    return {

      handle: formData.get('handle') || undefined,

      petName,
      petType,
      petBreed,

      birthdate,
      weight,
      gender,

      medication,
      allergies,
      existing_condition: conditions
    };
  }
  // Show validation error for a field
  showFieldError(field, message) {
    if (!field) return;

    this.clearFieldError(field);

    let parent =
      field.closest('.field-group') ||
      field.closest('.choices') ||
      field.parentElement;

    // highlight input
    field.classList.add('field-error');

    // highlight choices dropdown
    const choicesWrapper = field.closest('.choices');
    if (choicesWrapper) {
      choicesWrapper.classList.add('is-error');
    }

    // prevent duplicate error
    if (parent?.querySelector('.field-error-message')) return;

    const errorEl = document.createElement('div');
    errorEl.className = 'field-error-message';
    errorEl.textContent = message;

    parent?.appendChild(errorEl);
  }
}
customElements.define("pet-modal", PetModal);